import React, { useMemo, useState, useEffect } from 'react';
import { Card, Tabs } from 'antd';
import { useLanguage } from '../../../contexts/LanguageContext';
import StatementReport from './Statement/StatementReport';
import SalesOrderPivotReport from './SalesOrderPivot/SalesOrderPivotReport';

const CommerceReportsPage = ({ userInterfaces = [] }) => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('statement');

  const availableTabs = useMemo(() => {
    const tabs = [];
    if (userInterfaces.includes('reports.commerce.statement')) {
      tabs.push({
        key: 'statement',
        label: t('reports.commerce.statement') || 'Statement 月結',
        children: <StatementReport />
      });
    }
    if (userInterfaces.includes('reports.commerce.salesPivot')) {
      tabs.push({
        key: 'pivot',
        label: t('reports.commerce.salesPivot') || '銷售訂單 Pivot',
        children: <SalesOrderPivotReport />
      });
    }
    return tabs;
  }, [userInterfaces, t]);

  useEffect(() => {
    if (availableTabs.length > 0 && !availableTabs.find((tab) => tab.key === activeTab)) {
      setActiveTab(availableTabs[0].key);
    }
  }, [availableTabs, activeTab]);

  if (availableTabs.length === 0) {
    return (
      <Card>
        <div style={{ padding: 24, textAlign: 'center' }}>
          {t('reports.noCommerceReportsPermission') || '您沒有權限訪問商務管理報表'}
        </div>
      </Card>
    );
  }

  return (
    <Card title={t('reports.commerce.title') || '商務管理報表'}>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={availableTabs}
        destroyInactiveTabPane={false}
      />
    </Card>
  );
};

export default CommerceReportsPage;
